import { CountUp } from 'lib/countup.js';

class StatBox {
  constructor(el, {
    duration = 1500,
		delay = 1000
  } = {}) {
    const number = el.querySelector('.callout-stat-number');
    const finish = parseInt(el.dataset.stat);
    const suffix = el.dataset.statSuffix || '';
		const prefix = el.dataset.statPrefix || '';
    const options = {
      duration: duration / 1000,
			suffix,
			prefix
		};
		this.countup = new CountUp(number, finish, options);
    
    if (!this.countup.error) {
      setTimeout(() => this.countup.start(), delay);
    } else {
      console.error(this.countup.error);
    }
  }
}

// Auto-init when in view
function initStatBoxes() {
  const statElements = document.querySelectorAll('[data-stat]');

  statElements.forEach(el => {
    // Animate when element is in view, if not inside a swiper
    if (el.closest('.swiper-slide') == null) {
      let hasAnimated = false;

      // Helper to trigger the countup once
      function triggerStat() {
        if (hasAnimated) return;
        new StatBox(el, { delay: 0 });
        el.classList.add('animate');
        hasAnimated = true;
      }

      // Prefer IntersectionObserver when available
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          const entry = entries[0];

          if (entry.isIntersecting && !hasAnimated) {
            triggerStat();
            observer.unobserve(el);
          }
        }, {
          threshold: 0.25,
          rootMargin: '0px 0px -10% 0px'
        });

        observer.observe(el);
      } else {
        // Fallback: scroll-based detection (one-time)
        const windowHeight = window.innerHeight;

        function checkPosition() {
          // If this stat has already animated once, no need to keep checking
          if (hasAnimated) {
            window.removeEventListener('scroll', checkPosition);
            return;
          }

          const positionFromTop = el.getBoundingClientRect().top;
          // Trigger once when the element is in (or close to) view,
          // regardless of whether the user is scrolling up or down.
          if (positionFromTop - windowHeight <= -50) {
            triggerStat();

            // Once animated, we can stop listening for scroll on this element.
            window.removeEventListener('scroll', checkPosition);
          }
        }

        window.addEventListener('scroll', checkPosition);
        // Run once on load in case already in view
        checkPosition();
      }
    }
  });
}

// Run on page load
document.addEventListener('DOMContentLoaded', initStatBoxes);

// Make globally available
if (typeof window !== 'undefined') {
  window.StatBox = StatBox;
}

// Export so other modules can use
export { StatBox, initStatBoxes };